import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AiMlPage from './pages/AiMlPage';
import StaffAugmentationPage from './pages/StaffAugmentationPage';
import SapConsultingPage from './pages/SapConsultingPage';
import ManufacturingPage from './pages/ManufacturingPage';
import BankingPage from './pages/BankingPage';
import AutomotivePage from './pages/AutomotivePage';
import RetailPage from './pages/RetailPage';
import BlogPage from './pages/BlogPage';
import SinglePostPage from './pages/SinglePostPage';
import SapSuccessFactorsPage from './pages/SapSuccessFactorsPage';
import SapGrcPage from './pages/SapGrcPage';
import SapSecurityPage from './pages/SapSecurityPage';
import SapAribaPage from './pages/SapAribaPage';
import SapFicoPage from './pages/SapFicoPage';
import EmployeeCentralPage from './pages/EmployeeCentralPage';
import RecruitmentPage from './pages/RecruitmentPage';
import OnboardingPage from './pages/OnboardingPage'; // Import the new page
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us-2" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/ai-and-ml-consulting-services" element={<AiMlPage />} />
            <Route path="/top-sap-staff-augmentation-services" element={<StaffAugmentationPage />} />
            <Route path="/best-sap-consulting-services-usa" element={<SapConsultingPage />} />
            <Route path="/service/manufacturing" element={<ManufacturingPage />} />
            <Route path="/service/banking" element={<BankingPage />} />
            <Route path="/service/automotive" element={<AutomotivePage />} />
            <Route path="/service/sap-consulting-services-for-retail-industry" element={<RetailPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<SinglePostPage />} />
            <Route path="/service/sap-successfactors-consulting-hr-solutions" element={<SapSuccessFactorsPage />} />
            <Route path="/service/sap-grc-consulting-implementation-services" element={<SapGrcPage />} />
            <Route path="/service/sap-security-consulting-services" element={<SapSecurityPage />} />
            <Route path="/service/sap-ariba-consulting-and-implementation-services" element={<SapAribaPage />} />
            <Route path="/service/best-sap-fico-consultant-services-usa" element={<SapFicoPage />} />
            <Route path="/service/employee-central" element={<EmployeeCentralPage />} />
            <Route path="/service/recruitment" element={<RecruitmentPage />} />
            <Route path="/service/onboarding" element={<OnboardingPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
